import { buttonVariants } from '../components/ui/button'
import { cn } from '../lib/utils'

export function NotFoundPage() {
  return (
    <>
      <header className="page-heading">
        <div className="container">
          <span className="page-stat">404 · no match</span>
          <h1>This path is outside the index</h1>
          <p>The role may have closed and dropped out of the sweep, or the address may be wrong.</p>
        </div>
      </header>
      <main className="container section" id="main-content">
        <a className={cn(buttonVariants({ variant: 'outline' }))} href="/jobs">Browse the index</a>
      </main>
    </>
  )
}
